import React, {useState} from 'react'
import { Link } from 'react-router-dom'
import Appbar from '../../components/Appbar'
import { womanProducts } from '../../data/ProductData'

const WomanProducts = () => {
    const [showProduct, setShowProduct] = useState(womanProducts)
    
    const uniqueCategories = [
        ...new Set(showProduct.map((product) => product.category)),
      ];
      const handleFilterClick = (category) => {
        const filteredProducts = womanProducts.filter(
          (product) => product.proSelect === category
        );
        setShowProduct(filteredProducts);
      };
  
      const handleShowAllClick = () => {
        setShowProduct(womanProducts);
      }
      const showAllButton =
        showProduct.length !== womanProducts.length ? (
          <button className="ind-type" onClick={handleShowAllClick}>
            Show All
          </button>
        ) : null;
    

    return (
<div>
    <Appbar />
    <div className="page-section">
    <div className="bread-sec">
        <Link to="/" className="bread-link">
          <u>Home</u>
        </Link>
        <Link to="/mens" className="bread-link">
          <u>Men</u>
        </Link>
     
      </div>
        <div>
          {uniqueCategories.map((category) => (
            <h2 key={category}>{category}</h2>
          ))}
        </div>
        <div className="type-sec">
          {showProduct.map((item) => (
            <div
              className="ind-type"
              onClick={() => handleFilterClick(item.proSelect)}
            >
              {item.proSelect}
            </div>
          ))}
          {showAllButton}
        </div>

        <div className="men-show-sec">
          {showProduct.map((item) => (
            <div key={item.id}>
              <div className="show-pro">
                <Link to={`/w-multi/${item.id}`}>
                  <img src={item.proImg} alt={item.proName} />
                  <div>{item.proName}</div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

</div>
    )
}

export default WomanProducts;



{/* <div className='page-section'>
    <div className="bread-sec">Breadcrum</div>
        <div>
          {uniqueCategories.map((category) => (
            <h2 key={category}>{category}</h2>
          ))}
        </div>
        <div className="type-sec">
          {showProduct.map((item) => {
            return <div className="ind-type">{item.proSelect}</div>;
          })}
        </div>
        <div className='men-show-sec'>
          {showProduct.map((item)=>{
              return(
                  <div >
                      <div className="show-pro">
                          <Link to={`/w-multi/${item.id}`}>
                      <img src={item.proImg} alt={item.proName} />
                      <div>{item.proName}</div>
                          </Link>
                      </div>
                  </div>
              )
          })}
      </div>
  </div> */}